// import Manager
import { SettingHandlerManager } from '@/app/editor/sidebar/settings/setting-handler/BaseSettingHandler';

// import Setting Handler
import { ShCss, ShCssWidth } from '@/app/editor/sidebar/settings/setting-handler/ShCss';
import { ShCssNotSelector } from '@/app/editor/sidebar/settings/setting-handler/ShCssNotSelector';
import { ShCssBoxShadow } from '@/app/editor/sidebar/settings/setting-handler/ShCssBoxShadow';
import { ShCustomAlign } from '@/app/editor/sidebar/settings/setting-handler/ShCustomAlign';
import { ShExtraClass } from '@/app/editor/sidebar/settings/setting-handler/ShExtraClass';
import { ShAutoWrapLink } from '@/app/editor/sidebar/settings/setting-handler/ShAutoWrapLink';
import { ShHtmlAttr } from '@/app/editor/sidebar/settings/setting-handler/ShHtmlAttr';
import { ShProductPick } from '@/app/editor/sidebar/settings/setting-handler/ShProductPick';
import { ShBadgePositon } from '@/app/editor/sidebar/settings/setting-handler/ShBadgePositon';
import { ShBadgeRotateText } from '@/app/editor/sidebar/settings/setting-handler/ShBadgeRotateText';
import { ShBadgeDisplayType } from '@/app/editor/sidebar/settings/setting-handler/ShBadgeDisplayType';
import { ShBadgeGradient } from '@/app/editor/sidebar/settings/setting-handler/ShBadgeGradient';
import { ShBadgeRotateFrame } from '@/app/editor/sidebar/settings/setting-handler/ShBadgeRotateFrame';
import { ShBadgePositonDirection } from '@/app/editor/sidebar/settings/setting-handler/ShBadgePositonDirection';
import { ShHtmlMuti } from '@/app/editor/sidebar/settings/setting-handler/ShHtmlMuti';
import { ShFontStyle } from '@/app/editor/sidebar/settings/setting-handler/ShFontStyle';
import {
  ShPaginatorBtnSpacing,
  ShPaginatorLayout,
  ShPaginatorText,
} from '@/app/editor/sidebar/settings/setting-handler/ShForPaginator';

SettingHandlerManager.registerHandlerClass({
  /**
   * HTML SETTING
   */
  'html:extraClass': ShExtraClass,
  'html:autoWrapLink': ShAutoWrapLink,
  'html:attr': ShHtmlAttr,
  'html:muti': ShHtmlMuti,
  /**
   * CSS SETTING
   */
  css: ShCss,
  'css:font-style': ShFontStyle,
  'css:width': ShCssWidth,
  'css:notSelector': ShCssNotSelector,
  'css:boxShadow': ShCssBoxShadow,
  /**
   * PPRODUCT SETTING
   */
  'product:pick': ShProductPick,
  /**
   * PAGINATOR SETTING
   */
  'paginator:layout': ShPaginatorLayout,
  'paginator:btn-spacing': ShPaginatorBtnSpacing,
  'paginator:text': ShPaginatorText,
  /**
   * ANOTHER SETTING
   */
  'custom:align': ShCustomAlign,
  'badge:position': ShBadgePositon,
  'badge:positionDirection': ShBadgePositonDirection,
  'badge:rotatetext': ShBadgeRotateText,
  'badge:rotateframe': ShBadgeRotateFrame,
  'badge:displaytype': ShBadgeDisplayType,
  'badge:gradient': ShBadgeGradient,
});
